const vergence = {
  namespaced: true,
  state: {
    mode: 'Auto', // 'Auto' ? 'Manual'
    horizontal: {
      vergenceDemand: 0, // 聚散需求
      horizonAxis: '', // 当前水平基准视轴(摄像机)方向
      rangeMin: -3, //  水平基准视轴(摄像机)方向 运动范围
      rangeMax: 5, //  水平基准视轴(摄像机)方向 运动范围
      range: [-3, 5],
      moveMode: 'smooth', // \ 'jump'
      speed: 3, // 目标物移动速度，
      step: 1, // 跳跃模式下的移动幅度，每( step / speed )秒跳一次
    },
    vertical: {
      // 垂直方向视轴
      verticalAxis: '', // 当前垂直基准视轴(摄像机)方向
      range: [-5, 5],
      moveMode: 'smooth',
      speed: 1,
      step: 1,
    },
    rotation: {
      // 摄像机旋转 z轴
      zAxis: '', // 当前z轴基准视轴（摄像机）方向
      range: [-10, 10], // 圆周度
      moveMode: 'smooth', // \ 'jump'
      speed: 1,
      step: 1,
    },
  },
  mutations: {
    setVergenceMode: (state, val) => {
      state.mode = val
    },

    /**
     * 融像设置
     */
    update_VD_H: (state, step) => {
      let baseValue = state.horizontal.vergenceDemand
      let newValue = baseValue + step
      newValue.toFixed(0)
      state.horizontal.vergenceDemand = newValue
      // state.horizontal.vergenceDemand = constrain(
      //   newValue,
      //   state.horizontal.range[0],
      //   state.horizontal.range[1]
      // )
    },
    updateRangeMax: (state, step) => {
      let baseValue = state.horizontal.range[1]
      let newValue = baseValue + step
      newValue.toFixed(0)
      state.horizontal.range[1] = newValue
      console.log(state.horizontal.range[1], 'state.horizontal.range[1]')
    },
    updateRangeMin: (state, step) => {
      let baseValue = state.horizontal.range[0]
      let newValue = baseValue + step
      newValue.toFixed(0)
      state.horizontal.range[0] = newValue
    },
    setRange: (state, value) => {
      state.horizontal.range = value
    },
    setRangeMin: (state, value) => {
      state.horizontal.range[0] = value
    },
    setRangeMax: (state, value) => {
      state.horizontal.range[1] = value
    },
  },
  actions: {},
  getters: {
    // 水平反向融像速度 单位 px
    speed: (state, getters, rootState, rootGetters) => {
      let speed = state.horizontal.speed
      return rootGetters.prim2px(speed)
    },
    step: (state, getters, rootState, rootGetters) => {
      let step = state.horizontal.step
      return rootGetters.prim2px(step)
    },
    range: (state, getters, rootState, rootGetters) => {
      let range = state.horizontal.range
      let gRange = []
      gRange[0] = rootGetters.prim2px(range[0])
      gRange[1] = rootGetters.prim2px(range[1])
      return gRange
    },
    rangeMax: (state, getters, rootState, rootGetters) => {
      let rangeMax = state.horizontal.range[1]
      return rootGetters.prim2px(rangeMax)
    },
  },
}

export default vergence
